import React from 'react';
import OptionButton from '../shared/OptionButton';
import { WEEKDAYS } from '../onboardingQuestions';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const LongRunDayStep: React.FC<StepProps> = ({ answer, onAnswer, answers }) => {
  const restDays: number[] = answers.training_availability || [];
  const availableDays = WEEKDAYS.filter((d) => !restDays.includes(d.value as number));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {availableDays.map((day) => (
        <OptionButton
          key={day.value}
          label={day.label}
          value={day.value}
          selected={answer === day.value}
          onClick={onAnswer}
        />
      ))}
    </div>
  );
};

export default LongRunDayStep;
